export default {"src":"/stays/_next/static/media/GoogleRating.ecd95008.svg","height":31,"width":30,"blurWidth":0,"blurHeight":0};